import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "../src/Layouts/MainLayout";
//import BlankLayout from "./layouts/BlankLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
//import { useState } from "react";

//home folder routes
import Home from "./Home/Home";
import About from "./Home/About";
import Katalog from "./Home/Katalog";
import Contact from "./Home/Contact.js";

import Login from "./Private/Login.js";
import Jodustpanel from "./Private/Jodust-panel.js";
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />} >
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Katalog" element={<Katalog />} />
          <Route path="/Contact" element={<Contact />} />
        </Route>
      </Routes>

      <Routes>
        <Route path="/Login" element={<Login />} />
        <Route path="/Jodust-panel" element={<Jodustpanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
